<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="ModalBaslik"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
  >
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">

        <el-col :span="24">
          <el-form-item label="Personel Adı" prop="adi">
            <el-input type="text" v-model="Form.adi" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="Email" prop="email">
            <el-input type="text" v-model="Form.email" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Telefon" prop="telefon">
            <el-input type="text" v-model="Form.telefon" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Şifre" prop="pass">
            <el-input type="text" v-model="Form.pass" autocomplete="off"></el-input>
          </el-form-item>
          <p v-if="Tur=='Put'">Şifre Değiştirmek istemiyorsanız girmeyiniz.</p>
        </el-col>


        <el-col :span="24">
          <el-form-item label="Ekip" prop="Ekip_id">
            <el-select v-model="Form.Ekip_id" filterable placeholder="Ekip Seçiniz">
              <el-option
                  v-for="item in Ekip"
                  :key="item.id"
                  :label="item.adi"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>
  </el-dialog>

</template>

<script>
import BinaListe from "../../Bina/BinaListe";

export default {
  props: ['Bilgi', 'Durum', 'Tur'],
  data() {
    return {
      Ekip: '',
      ModalBaslik: '',
      lo: false,
      Form: {},
      FormHata: {
        adi: [{required: true, message: "Personel Adı Giriniz", trigger: 'blur'}],
        email: [{required: true, message: "Email Giriniz", trigger: 'blur'}],
      },
    }
  },
  methods: {
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          this.$store.dispatch(this.Tur, {...this.Form, path: 'personel'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                  if (this.Tur == 'Post') this.$router.push("/personel/");
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  },
  created() {
    if (this.Bilgi) {
      this.Form = this.Bilgi
      this.ModalBaslik = this.Bilgi.Unvan
    } else {
      this.Form = {}
      this.ModalBaslik = 'Personel Ekle'
    }
    this.$store.dispatch("Get", {path: 'personel'})
        .then(response => {
          this.Bolgeler = response.Data
        })
    this.$store.dispatch("Get", {path: 'ekip'})
        .then(response => {
          this.Ekip = response.Data
        })
  },
  watch: {
    Bilgi: function () {
      this.Form = this.Bilgi
      this.ModalBaslik = 'Personel Düzenle';

    },
    Tur: function () {
      if (this.Tur == 'Post') this.ModalBaslik = 'Personel Ekle'; else this.ModalBaslik = 'Personel Düzenle';
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/personel/Comp/Modal.vue